import type { Identifier, Resource } from '@medplum/fhirtypes'

/**
 * Sets a resource identifier for the given system.
 *
 * Note that this method is only available on resources that have an "identifier" property,
 * and that property must be an array of Identifier objects,
 * which is not true for all FHIR resources.
 *
 * If the identifier already exists, then the value is updated.
 *
 * Otherwise a new identifier is added.
 *
 * @param resource - The resource to add the identifier to.
 * @param system - The identifier system.
 * @param value - The identifier value.
 * @param rest - Additional properties to set on the identifier.
 */
export function setIdentifier(
  resource: Resource & { identifier?: Identifier[] },
  system: string,
  value: string,
  rest: Partial<Omit<Identifier, 'system' | 'value'>> = {}
): void {
  const identifiers = resource.identifier
  if (!identifiers) {
    resource.identifier = [{ system, value, ...rest }]
    return
  }
  for (const identifier of identifiers) {
    if (identifier.system === system) {
      identifier.value = value
      Object.assign(identifier, rest)
      return
    }
  }
  identifiers.push({ system, value, ...rest })
}
